<template>
  <b-container>
    <b-col class="mt-2">
      <div>
        <b-row class="form-group">
          <b-col offset="4" md="8" align="right">
            <b-button class="clear" @click="clearFilterData()">
              {{ $t("label_advancedData_clearFilters") }}
            </b-button>
            <b-button variant="primary" @click="getConsolidatedData()">
              {{ $t("label_advancedData_applyFilters") }}
            </b-button>
          </b-col>
        </b-row>
        <template-filters ref="filters" />
        <b-container v-if="error">
          <b-row>
            <b-col lg="8">
              {{ $t("label_advancedData_no_data") }}
            </b-col>
          </b-row>
        </b-container>
        <b-container v-if="!error">
          <b-row>
            <b-col lg="8">
              <card-general-index-consolidated height="165px" />
            </b-col>
            <b-col>
              <card-conventions
                :height="mdScreen ? 'auto' : '165px'"
                :orientation="mdScreen ? 'horizontal' : ''"
                :show-ideal="false"
                :show-company="false"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <card-chart-treemap-consolidated alias="treemap" />
            </b-col>
          </b-row>
          <b-row style="display: flex; justify-content: center">
            <b-col
              v-for="(pillar, index) in getPillarsIdsConsolidated"
              :key="index"
              md="6"
              lg="6"
              xl="4"
            >
              <card-chart-radar-consolidated
                :pillar-id="pillar"
                alias="report"
                height="450px"
              />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-col>
  </b-container>
</template>
<script>
import { mapGetters } from "vuex";
import CardChartRadarConsolidated from "./cards/CardChartRadarConsolidated";

export default {
  name: "ReportsGenderGap",
  components: { CardChartRadarConsolidated },
  data: function () {
    return {
      mdScreen: false,
      error: false,
    };
  },
  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
  },
  methods: {
    clearFilterData() {
      if (this.$refs.filters) {
        this.$refs.filters.clearFilters();
      }
      this.getConsolidatedData();
    },
    getConsolidatedData() {
      let parameters = {
        Companies: [],
        Tags: [],
        Years: [],
        Types: [],
        Locations: [],
        Sizes: [],
        Activities: [],
      };
      if (this.$refs.filters) {
        parameters = this.$refs.filters.getDataInFilters();
      }
      this.$store
        .dispatch("CONSOLIDATE_PILLARS_REPORT", parameters)
        .then((resp) => {
          if (resp.error) {
            this.error = true;
          } else {
            this.error = false;
          }
        })
        .catch((err) => {
          console.log(err);
          //  this.$router.push('/home') // TODO Handle the error in a better way
        });
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters([
      "getPillarsIdsConsolidated",
      "getBusiness",
      "getToken",
      "getCurrentSnapshot",
    ]),
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.mdScreen = true;
    }
    this.getConsolidatedData();
  },
};
</script>

<style lang="scss" scoped>

@import "../assets/css/variables.scss";

.positive {
  background-color: $positive-color;
}
.map {
  position: relative;
  margin-top: 20px;
  .btn {
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 30px;
    z-index: 100;
  }
}
h3 {
  font-size: 1.5rem;
  margin-top: 20px;
}
.col-lg-8,
.col,
.col-md-6,
.col-lg-6,
.col-xl-4 {
  padding-right: 5px;
  padding-left: 5px;
}

.clear{
  margin-right: 5px;
}

</style>
